var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.71094V23.7109H23M23 9.21094C23 10.0394 22.3284 10.7109 21.5 10.7109C20.6716 10.7109 20 10.0394 20 9.21094C20 8.38251 20.6716 7.71094 21.5 7.71094C22.3284 7.71094 23 8.38251 23 9.21094ZM19 16.2109C19 17.0394 18.3284 17.7109 17.5 17.7109C16.6716 17.7109 16 17.0394 16 16.2109C16 15.3825 16.6716 14.7109 17.5 14.7109C18.3284 14.7109 19 15.3825 19 16.2109ZM11.5 13.7109C12.3284 13.7109 13 13.0394 13 12.2109C13 11.3825 12.3284 10.7109 11.5 10.7109C10.6716 10.7109 10 11.3825 10 12.2109C10 13.0394 10.6716 13.7109 11.5 13.7109Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.0f1209818242c0785b2461bd4691c7cc.svg";
export { ForwardRef as ReactComponent };